import React, { Fragment } from 'react'
import PageHeader from '../PageHeader'
import GoogleMapReact from 'google-map-react'
import mapStyle from './map_style'

const MyMarker = () => <div className="gmaps-master-marker" />

export default class Contact extends React.Component {
  renderMarkers(map, maps, position) {
    new maps.Marker({
      position: position,
      map,
      title: 'Mästerhuset'
    })
  }
  render() {
    const content = this.props.content
    return (
      <Fragment>
        <div className="contact-container content-container">
          <PageHeader
            image={content.thumbnail}
            className="custom-text"
            title={
              content.post_content
                ? content.post_content
                : 'For all your needs, a member of our team is happy to help.'
            }
          />
          <section className="col-layout people-grid">
            {content.acf.people.map((a, i) => {
              return (
                <div className="col-33" key={i}>
                  <div
                    className="back"
                    style={
                      a.image
                        ? {
                            backgroundImage:
                              'url(' + a.image.sizes.medium_large + ')'
                          }
                        : {}
                    }
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: a.content ? a.content : ''
                    }}
                  />
                </div>
              )
            })}
          </section>
          <section className="col-layout">
            <div className="col">
              <h2
                dangerouslySetInnerHTML={{
                  __html: content.acf.title ? content.acf.title : ''
                }}
              />
            </div>
            <div
              className="col"
              dangerouslySetInnerHTML={{
                __html: content.acf.adress ? content.acf.adress : ''
              }}
            />
          </section>
        </div>
        <div style={{ height: '50vh', width: '100%' }}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: 'AIzaSyBvBTX7yzLZKqq6V64_4TcTXy86l-nF7pM'
            }}
            options={{
              styles: mapStyle
            }}
            defaultCenter={{
              lat: parseFloat(content.acf.map.lat),
              lng: parseFloat(content.acf.map.lng)
            }}
            defaultZoom={18}
            yesIWantToUseGoogleMapApiInternals
          >
            <MyMarker
              lat={parseFloat(content.acf.map.lat)}
              lng={parseFloat(content.acf.map.lng)}
            />
          </GoogleMapReact>
        </div>
      </Fragment>
    )
  }
}
